import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        options: {
            customProperties: true,
        },
        themes: {
            light: {
                primary: '#EB2C45',
                secondary: '#272727',
                accent: '#82B1FF',
                error: '#FF5252',
                info: '#FFFFFF',
                success: '#4CAF50',
                warning: '#FFC107',
            },
        },
    },
});
